// The German date formats of every app (`$df(date, name)`). An app overrides a key in its own i18n.config, as
// `client` does for `dateTime`. FormattedDateRange needs timeNumeric and the WithoutYear variants in every app.
export default {
    dateLong: {year: 'numeric', month: 'long', day: 'numeric'},
    dateLongWeekday: {year: 'numeric', month: 'long', day: 'numeric', weekday: 'short'},
    dateLongWeekdayWithoutYear: {month: 'long', day: 'numeric', weekday: 'short'},
    dateLongWithoutDay: {year: 'numeric', month: 'long'},
    dateLongWithoutYear: {month: 'long', day: 'numeric'},
    dateNumeric: {year: 'numeric', month: '2-digit', day: '2-digit'},
    dateNumeric2Digit: {year: '2-digit', month: '2-digit', day: '2-digit'},
    dateNumeric2DigitWeekday: {year: '2-digit', month: '2-digit', day: '2-digit', weekday: 'short'},
    dateNumericDay: {day: 'numeric'},
    dateNumericWeekday: {year: 'numeric', month: '2-digit', day: '2-digit', weekday: 'short'},
    dateNumericWeekdayWithoutYear: {month: '2-digit', day: '2-digit', weekday: 'short'},
    dateNumericWithoutDay: {year: 'numeric', month: 'numeric'},
    dateNumericWithoutYear: {month: '2-digit', day: '2-digit'},
    dateShort: {year: 'numeric', month: 'short', day: 'numeric'},
    dateShortMonth: {month: 'short', day: '2-digit'},
    dateShortWeekday: {year: 'numeric', month: 'short', day: 'numeric', weekday: 'short'},
    dateShortWithoutDay: {year: 'numeric', month: 'short'},
    dateTime: {year: 'numeric', month: 'short', day: 'numeric', weekday: 'short', hour: 'numeric', minute: 'numeric'},
    dateTimeLong: {year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric'},
    dateTimeLongWeekday: {year: 'numeric', month: 'long', day: 'numeric', weekday: 'short', hour: 'numeric', minute: 'numeric'},
    dateTimeNumeric: {year: 'numeric', month: '2-digit', day: '2-digit', hour: 'numeric', minute: 'numeric'},
    dateTimeNumericWeekday: {year: 'numeric', month: '2-digit', day: '2-digit', hour: 'numeric', minute: 'numeric', weekday: 'short'},
    dateTimeNumericWithoutYear: {month: '2-digit', day: '2-digit', hour: 'numeric', minute: 'numeric'},
    dateTimeShort: {year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'},
    dateTimeWeekday: {year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', weekday: 'short'},
    monthShort: {month: 'short'},
    time: {hour: 'numeric', minute: 'numeric'},
    timeNumeric: {hour: 'numeric', minute: 'numeric'},
    timeNumericDetailed: {hour: 'numeric', minute: 'numeric', second: 'numeric'},
    year: {year: 'numeric'},
}
